(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["beeplastic-form-space"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!('IntersectionObserver' in window)) return;

    const visibleForms = new Set();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visibleForms.add(entry.target);
        else visibleForms.delete(entry.target);
      });
      document.body.classList.toggle('bp-contact-in-view', visibleForms.size > 0);
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0 });

    const observeForms = () => {
      observer.disconnect();
      visibleForms.clear();
      document.body.classList.remove('bp-contact-in-view');
      document.querySelectorAll('form').forEach((form) => {
        if (form.querySelector('input[name="form_type"][value="contact"]')) {
          form.classList.add('bp-contact-space');
          observer.observe(form);
        }
      });
    };

    observeForms();
    document.addEventListener('shopify:section:load', observeForms);
    document.addEventListener('shopify:section:unload', observeForms);
  })();
  } catch(e) { console.error(e); }
})();

})();
